import CityPageTemplate from "../city-template/CityPageTemplate";
import { ranchoCucamongaConfig } from "./data";

export default function RanchoCucamongaPage() {
  return <CityPageTemplate config={ranchoCucamongaConfig} />;
}